import { PissOMeterState } from './reducers';

export const getPissState = (state: PissOMeterState) => state;